import React from "react";
import { CheckoutRoute } from "@swiggy-private/checkout-core";
import { CartRenderer } from "@cart-client/components/cart-renderer";
import { CouponListing } from "@cart-client/components/coupon-listing";
import { CartMain } from "@cart-client/components/cart-main";
import { GroupCartRenderer } from "@cart-client/components/group-cart-renderer";
// gifting
import { GiftingCartRenderer, GiftingCouponListing } from "@cart-client/components/gifting-cart";
// toing
import { ToingCartRenderer } from "@cart-client/components/toing-cart-renderer";
// lazy loaded cart routes
import { MROCouponListingRoute, MROFoodCartRoute, QuickCheckoutCartRoute } from "./LazyLoadedCartRoutes";

// Cart routes that require SwitchTransition `out-in` (via Router.nonOverlappingTransitionRoutes).
// Quick Checkout must exit the previous screen before entering so webview height / bg callbacks
// registered on navigateTo do not run while two cart screens still overlap.
export const CART_OUT_IN_ROUTES = [CheckoutRoute.QUICK_CHECKOUT];

export const CartRoutes = [
    <CartMain
        name={CheckoutRoute.CART}
        key={CheckoutRoute.CART}
        indexElement={<CartRenderer name={CheckoutRoute.CART} key={CheckoutRoute.CART} />}
    >
        <GroupCartRenderer name={CheckoutRoute.SHARED_CART} key={CheckoutRoute.SHARED_CART} />
        <CouponListing name={CheckoutRoute.COUPON_LISTING} key={CheckoutRoute.COUPON_LISTING} />

        {/* Gifting Routes */}
        <GiftingCartRenderer name={CheckoutRoute.GIFTING_CART} key={CheckoutRoute.GIFTING_CART} />
        <GiftingCouponListing name={CheckoutRoute.GIFTING_COUPON_LISTING} key={CheckoutRoute.GIFTING_COUPON_LISTING} />

        {/* Toing Routes */}
        <ToingCartRenderer name={CheckoutRoute.TOING_CART} key={CheckoutRoute.TOING_CART} />

        {/* MRO (Multi-Restaurant Order) Routes */}
        <MROFoodCartRoute name={CheckoutRoute.MRO_FOOD_CART} key={CheckoutRoute.MRO_FOOD_CART} />
        <MROCouponListingRoute
            name={CheckoutRoute.MRO_FOOD_COUPON_LISTING}
            key={CheckoutRoute.MRO_FOOD_COUPON_LISTING}
        />

        {/* Quick Checkout Routes */}
        <QuickCheckoutCartRoute name={CheckoutRoute.QUICK_CHECKOUT} key={CheckoutRoute.QUICK_CHECKOUT} />
    </CartMain>,
];
